import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';

const FormHeader = ({ title, subtitle }) => {
  return (
    <View style={styles.header}>
      {title ? <Text style={[styles.title, { color: 'white' }]}>{title}</Text> : null}
      {subtitle ? <Text style={[styles.subtitle, { color: 'white' }]}>{subtitle}</Text> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 32,
  },
  title: {
    alignSelf: 'stretch',
    textAlign: 'center',
    fontSize: 64,
    fontFamily: 'Chivo',
    fontWeight: '600',
    lineHeight: 32,
    color: '#fff',
      ...Platform.select({
          web: {
              textShadow: '2px 5px 1px rgba(0,0,0,1)',
          },
          default: {
              textShadowColor: 'rgba(0,0,0,1)',
              textShadowOffset: { width: 2, height: 2 },
              textShadowRadius: 1,
          },
      }),
  },
  subtitle: {
    alignSelf: 'stretch',
    textAlign: 'center',
    fontSize: 22,
    fontFamily: 'Chivo',
    fontWeight: '400',
    lineHeight: 18,
          ...Platform.select({
          web: {
              textShadow: '2px 2px 1px rgba(0,0,0,1)',
          },
          default: {
              textShadowColor: 'rgba(0,0,0,1)',
              textShadowOffset: { width: 2, height: 2 },
              textShadowRadius: 1,
          },
      }),
  },
});

export default FormHeader;


